import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useMap } from 'react-leaflet'
import styles from './styles.module.scss'

export type TilesetKey = 'topo' | 'satellite' | 'street'

export interface TilesetOption {
  key: TilesetKey
  label: string
  url: string
  subdomains?: string
}

export const TILESETS: TilesetOption[] = [
  {
    key: 'topo',
    label: 'Topo',
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    subdomains: 'abc',
  },
  {
    key: 'satellite',
    label: 'Satellite',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
  },
  {
    key: 'street',
    label: 'Street',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    subdomains: 'abc',
  },
]

interface Props {
  selected: TilesetKey
  onChange: (key: TilesetKey) => void
}

const TileLayerSelector: React.FC<Props> = ({ selected, onChange }) => {
  const map = useMap()
  const [container, setContainer] = useState<Element | null>(null)

  useEffect(() => {
    setContainer(map.getContainer().querySelector('.leaflet-top.leaflet-right'))
  }, [map])

  if (!container) return null

  return createPortal(
    <div className={`leaflet-control leaflet-bar ${styles.tileSelector}`}>
      {TILESETS.map((tileset) => (
        <button
          key={tileset.key}
          title={`${tileset.label} map`}
          aria-role="button"
          aria-pressed={selected === tileset.key}
          className={selected === tileset.key ? styles.active : ''}
          onClick={(e) => {
            e.preventDefault()
            onChange(tileset.key)
          }}
        >
          {tileset.label}
        </button>
      ))}
    </div>,
    container,
  )
}

export default TileLayerSelector
